import { MINOR_WORDS } from "./constants"
import moment from "moment"

export function convertFileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = (error) => reject(error)
  })
}

export function createPhotoInput(file) {
  return new Promise((resolve) => {
    convertFileToBase64(file).then((data) =>
      resolve({
        name: file.name,
        data,
      })
    )
  })
}

export function titleCase(title, delimiter) {
  return title
    .split(delimiter ?? " ")
    .map((word) => {
      return MINOR_WORDS.includes(word.toLowerCase())
        ? word
        : word.charAt(0).toUpperCase() + word.slice(1)
    })
    .join(" ")
}

export function booleanToOptionStatus(value) {
  if (value === true) return "success"
  if (value === false) return "fail"
  return "missing"
}

export function getFormattedDate(dateString, type = "") {
  const parsedDate = moment.utc(dateString).local() // Convert UTC to local time
  const currentDate = moment.utc().local() // Get current time in local timezone

  const diffInDays = currentDate.diff(parsedDate, "days")

  let displayDate

  if (type == "project") {
    if (diffInDays === 0) {
      displayDate = "Today"
    } else if (diffInDays === 1) {
      displayDate = "Yesterday"
    } else if (diffInDays < 30) {
      displayDate = diffInDays + " days ago"
    } else {
      displayDate = "on " + parsedDate.format("MMM D, YYYY")
    }
  } else {
    if (diffInDays === 0) {
      displayDate = "Today at " + parsedDate.format("h:mm A")
    } else if (diffInDays === 1) {
      displayDate = "Yesterday at " + parsedDate.format("h:mm A")
    } else {
      displayDate = parsedDate.format("DD MMM YYYY [at] hh:mm A")
    }
  }

  return displayDate
}
